import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})
export class ImagePreviewComponent implements OnInit {

  @Input() data = {image: null, name: null};
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    
  }

  closeModal() {
    this.activeModal.close({success: false})
  }

}
